<template>
    <marketing-automation-form-panel-section title="Definir campanhas">

        <CampaignTreeFilter id="campaignTree"
                            :value="formattedCampaginsArray"
                            :campaigns="campaigns"
                            @input="emitChangeTest"
                            />        
        
    </marketing-automation-form-panel-section>
</template>
<script>
import MarketingAutomationFormPanelSection
    from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection";
import CampaignTreeFilter from "@components/filters/CampaignTreeFilter.vue";
import vModel from "@mixins/v-model";
import {cloneDeep} from "lodash";


export default {
    components: {
        MarketingAutomationFormPanelSection,
        CampaignTreeFilter,
    },


    data() {
        return {         
            campaigns: [],
            formattedCampaginsArray: []
        };
    },

    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Object,
            default() {
                return {
                    campaigns: [],
                    interactions: [],
                    options: [],
                    npsValues: []                
                };
            },
        },
    },

    computed: {
        establishmentId() {
            return this.$store.state.users.user.accountId
        },        
    },

    watch: {
        value() {
            this.$nextTick(() => this.hideSelectedNpsScores())
        }
    },
    
    async created() {
     await this.loadCampaigns();
     this.formatCampaignsFilterArray(this.value)
          
    },    

    methods: {        
        sliderInput(evt) {
            this.val.npsInitial = evt[0];
            this.val.npsFinal = evt[1];

            this.$emit("input", this.val);
        },
        emitChangeTest(val) {

            val.map(fullId => {
                const type = fullId.split("-")[1]

                if(type === "int") {
                    this.campaigns.map(campaign => {
                        const selectedInteraction =  campaign.interactions.find(interaction => interaction.id === fullId)
                        if(selectedInteraction && selectedInteraction.type === "PESQUISA_NPS") {
                            selectedInteraction.options.map(option => option.isDisabled = false)
                        }
                    })
                }
            })
            
            const value = cloneDeep(this.val);
            const campaignsIds = []
            const interactionsIds = []
            const optionsIds = []
            const npsValuesIdsAndScores = []
            
            val.map(fullId => {
                const id = fullId.split("-")[0]
                const type = fullId.split("-")[1]
                const npsIdentifier = fullId.split("-")[2]

                if(type === "camp") {
                    campaignsIds.push(id)
                }
                if(type === "int") {
                    interactionsIds.push(id)
                    if(npsIdentifier === "nps") {
                        const newNpsInteractionWithScores = {
                            interactionId: id,
                            scores: []
                        }
                        npsValuesIdsAndScores.push(newNpsInteractionWithScores)
                    }
                }
                if(type === "opt") {
                    optionsIds.push(id)
                }
                if(type === "score") {               
                  npsValuesIdsAndScores.map(nps => {
                    if(nps.interactionId === npsIdentifier) {                        
                        if(!nps.scores.includes(Number(id)))
                            nps.scores.push(Number(id))
                    }
                  })

                }
            })
            value.campaigns = campaignsIds;
            value.interactions = interactionsIds;
            value.options = optionsIds
            value.npsValues = npsValuesIdsAndScores
            this.campaigns.map(campaign => {
                campaign.interactions.map(interaction => {
                    if(interaction.type === "PESQUISA_NPS" && !value.interactions.includes(interaction.id.split("-")[0])) {
                        interaction.options.map(option => option.isDisabled = true)
                    }
                })
            })
            this.$emit("input", value);
        },        
        async loadCampaigns() {
            try {
             this.campaignsLoaded = false;
  
            const list = await this.$api.marketing.automation.campaignTree.getCampaignTree(this.establishmentId)

            list.map(campaign => {
                campaign.id = campaign.id + "-camp";
                campaign.interactions.map(interaction => {
                    interaction.id = interaction.id + "-int"
                    if(this.value.interactions.includes(Number(interaction.id.split("-")[0]))) {
                        campaign.isDefaultExpanded = true
                    }            
                    if(interaction.type === "PESQUISA_NPS") {
                        interaction.id += "-nps"
                        const npsValues = []
                        for(let i = 0; i < 11; i++) {
                            const value = {
                                id: i + "-score" + `-${interaction.id.split("-")[0]}`,
                                name: i,
                                isDisabled: true
                            }
                            npsValues.push(value)
                        }
                        interaction.options = npsValues
                    }
                    if(interaction.type !== "PESQUISA_NPS") {
                        interaction.options.map(option => option.id = option.id + "-opt")
                    }
                    
                    interaction.options.map(option => {
                        if(this.value.options.includes(Number(option.id.split("-")[0]))) {
                            campaign.isDefaultExpanded = true
                            interaction.isDefaultExpanded = true
                        }
                    })
                })
          })
  
          this.campaigns = [...list];
  
          this.campaignsLoaded = true;
        } catch (error) {
          console.log(error);
        }
      },
      formatCampaignsFilterArray(
        value
        ) {
            const formattedArray = []
            
            this.campaigns.map(campaign => {
                campaign.interactions.map(interaction => {
                    const isSelectedNpsInteraction = !!this.value.npsValues.find(nps => Number(nps.interactionId) === Number(interaction.id.split("-")[0]))  
                    
                    if(interaction.type === "PESQUISA_NPS" && !isSelectedNpsInteraction) {
                        interaction.options.map(score => formattedArray.push(score.id))
                    }
                    
                })
            })            

            value.campaigns.map(campaignId => {
                formattedArray.push(campaignId + "-camp")
            })

            value.interactions.map(interactionId => {
                const isSelectedNpsInteraction = value.npsValues.find(nps => nps.interactionId === interactionId)
                if(isSelectedNpsInteraction) return
                formattedArray.push(interactionId + "-int")
            })

            value.options.map(optionId => {
                this.campaigns.map(campaign => {
                    campaign.interactions.map(interaction => {
                        interaction.options.map(option => {
                            if(option.id.split("-")[0] == optionId) {
                                formattedArray.push(optionId + "-opt")
                            }
                        })
                    })
                })
            })
            
            value.npsValues.map(nps => {
                formattedArray.push(nps.interactionId + "-int" + "-nps")
                nps.scores.map(score => formattedArray.push(score + "-score-" + nps.interactionId))
            })
            
            this.formattedCampaginsArray = [...formattedArray]
      },
      hideSelectedNpsScores() {
        const items = Array.from(document.getElementsByClassName("vue-treeselect__multi-value-item"))
        items.map(item => {
           const divWithValue = item.children[0].children[0]
           if(this.textContextIsNumber(divWithValue)) {
            item.style.display = "none"
            item.parentElement.style.display = "none"
           }
        })        
      },
      textContextIsNumber(div) {
        if(div.textContent === "0" ||
           div.textContent === "1" ||
           div.textContent === "2" ||
           div.textContent === "3" ||
           div.textContent === "4" ||
           div.textContent === "5" ||
           div.textContent === "6" ||
           div.textContent === "7" ||
           div.textContent === "8" ||
           div.textContent === "9" ||
           div.textContent === "10") {
            return true
           } else {
            return false
           }
      },
      expandParentsOfSelectedNodes() {
        this.campaigns.map(campaign => {
            campaign.interactions.map(interaction => {
                if(this.value.interactions.includes(interaction.id.split("-")[0].toString())) {
                    campaign.isDefaultExpanded = true
                }
            })
        })
      }
    },    

    mixins: [vModel]

}
</script>

<style>
    .marketing-automation-form-panel-entry-section-select {
        margin: 0 auto;
    }    

    .padding {
        padding: 0 10px
    }

    .slider-container {
        display: flex;
        flex-direction: column;
    }

    .slider-title {
        font-size: 14px;
        font-weight: 500;
        color: #4d4f5c;
    }
</style>
